import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AuthContext = createContext(null);

const API_BASE = "";

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({
    loading: true,
    authenticated: false,
    admin: null,
  });

  const checkAuth = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    try {
      const res = await fetch(`${API_BASE}/api/auth/me`, {
        method: "GET",
        credentials: "include",
        signal: controller.signal,
      });

      if (!res.ok) {
        setAuth({
          loading: false,
          authenticated: false,
          admin: null,
        });
        return;
      }

      const data = await res.json();

      setAuth({
        loading: false,
        authenticated: !!data.authenticated,
        admin: data.admin || null,
      });
    } catch (err) {
      console.error("checkAuth error:", err);
      setAuth({
        loading: false,
        authenticated: false,
        admin: null,
      });
    } finally {
      clearTimeout(timeout);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async ({ username, password }) => {
    const res = await fetch(`${API_BASE}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ username, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.error || "Login incorrecto");
    }

    setAuth({
      loading: false,
      authenticated: true,
      admin: data.admin || null,
    });

    return data;
  };

  const logout = async () => {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } finally {
      setAuth({
        loading: false,
        authenticated: false,
        admin: null,
      });
    }
  };

  const value = useMemo(
    () => ({
      ...auth,
      login,
      logout,
      checkAuth,
    }),
    [auth]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return ctx;
}